import { useEffect, useState } from 'react';
import UserConfigurationTable from '../../../components/commonComponent/UserConfigurationTable';
import { BASE_URL } from '../../../constants/apiConstants';
import axiosInstance from '../../../api/axios';
import Loader from '../../../components/loader/Loader';
import { IconButton, InputBase, Paper } from '@mui/material';
import { IconSearch } from '../../../icons/Icon';
import useDebounce from '../../../hooks/useDebounce';


type User = {
  userid: string;
  emailid: string;
  username: string;
  userrole: string;
  lastlogin: string | null;
  isactive: string;
};

type UserResponse = {
  success: boolean;
  message: string;
  data: User[];
  responsecode: number;
  errormessage: string | null;
};

const UserConfiguration = () => {
  const [data, setData] = useState<UserResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const debouncedSearch = useDebounce(searchQuery, 800);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get<UserResponse>(`${BASE_URL}/api/v1/User/GetAllUser`);
      setData(res.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  
  // On mount
  useEffect(() => {
    fetchUsers();
  }, []); 
  
  // Filtered sites based on the search query
  const filteredData = !loading && data?.data
  ? data.data.filter((user: User) => {
      const searchLower = (debouncedSearch ?? '').toLowerCase().trim();
      return (user.username?.toLowerCase().includes(searchLower) || user.emailid?.toLowerCase().includes(searchLower));
    })
  : [];

  return (
    <div className="content-wrapper">
      <div className='flex justify-content-between align-items-center mb-12'>
        <h1 className="flex align-items-center">User Configuration</h1>
          <Paper component="form" className="search-input mr-12">
            <InputBase
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)} onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
            />
            <IconButton type="button" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
      </div>
      <div className="white-box mb-12">
        <div className="inner-contant kitchen-dashboard">
          <UserConfigurationTable users={filteredData ?? []} />
           {loading && <Loader />}
        </div>
      </div>
    </div>
  );
};

export default UserConfiguration;
